/* global console */
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateSpacerColor } from "../../../state/spacerStylesSlice";
import ColorPickerSubMenu from "../submenus/ColorPickerSubMenu";

const SpacerBackgroundColorMenuItem = () => {
  const dispatch = useDispatch();
  const selection = useSelector((state) => state.selection);
  const spacerStyles = useSelector((state) => state.gridd.present.spacerStyles);
  const cellStyles = useSelector((state) => state.gridd.present.cellStyles);

  const isVerticalSpacer = selection.columns.length > 0;
  const isHorizontalSpacer = selection.rows.length > 0;

  let selectedSpacerCoordinates = null;
  let spacerCellId = null;

  if (isVerticalSpacer) {
    selectedSpacerCoordinates = { type: "column", index: selection.columns[0] };
    spacerCellId = selection.cells[0]?.id;
  } else if (isHorizontalSpacer) {
    selectedSpacerCoordinates = { type: "row", index: selection.rows[0] };
    spacerCellId = selection.cells[0]?.id;
  }

  const spacerColor = selectedSpacerCoordinates
    ? selectedSpacerCoordinates.type === "column"
      ? spacerStyles?.columnColors[selectedSpacerCoordinates.index]
      : spacerStyles?.rowColors[selectedSpacerCoordinates.index]
    : null;
  const cellBackgroundColor = cellStyles[spacerCellId]?.background;
  const currentColor = spacerColor || cellBackgroundColor;

  return (
    <div id="context_menu_item_spacer_background" style={{ display: "grid", gridTemplateRows: "auto, 1fr" }}>
      <div>
        <ColorPickerSubMenu
          id="spacer_background_color"
          color={currentColor}
          enabled={["nocolor", "background", "base", "diverging", "sequential", "status"]}
          onNewColor={(newColor) => {
            console.log("SpacerBackgroundColorMenuItem - Color selected:", {
              newColor,
              selectedSpacerCoordinates,
              isVerticalSpacer,
              isHorizontalSpacer,
              selection,
            });

            if (selectedSpacerCoordinates) {
              dispatch(
                updateSpacerColor({
                  type: selectedSpacerCoordinates.type,
                  index: selectedSpacerCoordinates.index,
                  color: newColor,
                })
              );
            }
          }}
        />
      </div>
    </div>
  );
};

export default SpacerBackgroundColorMenuItem;
